import React from 'react';
import { Button, Card, Typography, Space, Divider } from 'antd';
import { ArrowLeftOutlined, MailOutlined, ClockCircleOutlined, FileTextOutlined, UsergroupAddOutlined, SafetyOutlined, ExclamationCircleOutlined, ShopOutlined, CrownOutlined, TeamOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph, Text } = Typography;

const TermsOfServicePage = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1); // Geri git
  };

  return (
    <div style={{ padding: '24px', maxWidth: '800px', margin: '0 auto' }}>
      {/* Header */}
      <Card style={{ marginBottom: '24px', textAlign: 'center' }}>
        <Space direction="vertical" size="small">
          <Button 
            type="link" 
            icon={<ArrowLeftOutlined />} 
            onClick={handleBack}
            style={{ alignSelf: 'flex-start' }}
          >
            Geri Dön
          </Button>
          <Title level={2} style={{ color: '#1890ff', margin: 0 }}>
            📜 Kullanım Şartları
          </Title>
          <Text type="secondary" style={{ fontStyle: 'italic' }}>
            Son Güncelleme: Ocak 2025
          </Text>
        </Space>
      </Card>

      {/* Content */}
      <Card>
        {/* Siparify Nedir */}
        <div style={{ marginBottom: '32px' }}>
          <Title level={3} style={{ color: '#1890ff', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <ShopOutlined /> Siparify Nedir?
          </Title>
          <Paragraph>
            Siparify, işletmelerin sipariş süreçlerini dijital ortamda takip etmelerini sağlayan bir B2B platformudur.
          </Paragraph>
        </div>

        {/* Neler Yapabilirsiniz */}
        <div style={{ marginBottom: '32px' }}>
          <Title level={3} style={{ color: '#1890ff', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <FileTextOutlined /> Neler Yapabilirsiniz?
          </Title>
          <Paragraph>
            <ul style={{ paddingLeft: '20px' }}>
              <li>Sipariş oluşturma ve takip etme</li>
              <li>Çalışan ve şirket yönetimi</li>
              <li>Dosya paylaşımı ve raporlama</li>
              <li>Gerçek zamanlı durum güncellemeleri</li>
            </ul>
          </Paragraph>
        </div>

        {/* Kullanıcı Sorumlulukları */}
        <div style={{ marginBottom: '32px' }}>
          <Title level={3} style={{ color: '#1890ff', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <UsergroupAddOutlined /> Kullanıcı Sorumlulukları
          </Title>
          <Paragraph>
            <ul style={{ paddingLeft: '20px' }}>
              <li>Doğru bilgiler sağlayın</li>
              <li>Hesap bilgilerinizi güvende tutun</li>
              <li>Sistemi kötüye kullanmayın</li>
              <li>Diğer kullanıcılara saygı gösterin</li>
            </ul>
          </Paragraph>
        </div>

        {/* Yasak Olan Şeyler */}
        <div style={{ marginBottom: '32px' }}>
          <Title level={3} style={{ color: '#ff4d4f', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <ExclamationCircleOutlined /> Yasak Olan Şeyler
          </Title>
          <Card style={{ background: '#fff2f0', borderLeft: '4px solid #ff4d4f' }}>
            <ul style={{ paddingLeft: '20px', margin: 0 }}>
              <li>Başkalarının hesaplarına erişmeye çalışmak</li>
              <li>Zararlı dosyalar yüklemek</li>
              <li>Sistemi hacklemeye çalışmak</li>
              <li>Spam veya istenmeyen içerik göndermek</li>
            </ul>
          </Card>
        </div>

        {/* Hesap Türleri */}
        <div style={{ marginBottom: '32px' }}>
          <Title level={3} style={{ color: '#1890ff', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <TeamOutlined /> Hesap Türleri
          </Title>
          <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            <Card 
              style={{ 
                background: 'linear-gradient(135deg, #fffbf0, #fff2e6)', 
                borderLeft: '4px solid #fa8c16' 
              }}
            >
              <Space>
                <CrownOutlined style={{ color: '#fa8c16', fontSize: '20px' }} />
                <div>
                  <Text strong style={{ color: '#ad6800' }}>👑 Yönetici:</Text>
                  <Text style={{ marginLeft: '8px' }}>Tüm sistemi yönetir</Text>
                </div>
              </Space>
            </Card>
            
            <Card 
              style={{ 
                background: 'linear-gradient(135deg, #f0f9ff, #e6f4ff)', 
                borderLeft: '4px solid #1890ff' 
              }}
            >
              <Space>
                <ShopOutlined style={{ color: '#1890ff', fontSize: '20px' }} />
                <div>
                  <Text strong style={{ color: '#0958d9' }}>🏢 Şirket:</Text>
                  <Text style={{ marginLeft: '8px' }}>Sipariş oluşturur ve takip eder</Text>
                </div>
              </Space>
            </Card>
            
            <Card 
              style={{ 
                background: 'linear-gradient(135deg, #f6ffed, #d9f7be)', 
                borderLeft: '4px solid #52c41a' 
              }}
            >
              <Space>
                <UsergroupAddOutlined style={{ color: '#52c41a', fontSize: '20px' }} />
                <div>
                  <Text strong style={{ color: '#389e0d' }}>👥 Çalışan:</Text>
                  <Text style={{ marginLeft: '8px' }}>Atanan siparişleri günceller</Text>
                </div>
              </Space>
            </Card>
          </Space>
        </div>

        {/* Veri Güvenliği */}
        <div style={{ marginBottom: '32px' }}>
          <Title level={3} style={{ color: '#1890ff', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <SafetyOutlined /> Veri Güvenliği
          </Title>
          <Paragraph>
            Verilerinizi güvenli şekilde saklıyoruz ve KVKK/GDPR gerekliliklerine uyuyoruz. 
            Verilerinizi üçüncü taraflarla paylaşmıyoruz.
          </Paragraph>
        </div>

        {/* Hizmet Kesintileri */}
        <div style={{ marginBottom: '32px' }}>
          <Title level={3} style={{ color: '#1890ff', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <ClockCircleOutlined /> Hizmet Kesintileri
          </Title>
          <Paragraph>
            <ul style={{ paddingLeft: '20px' }}>
              <li>%99 uptime hedefliyoruz</li>
              <li>Planlı bakımları önceden duyururuz</li>
              <li>Teknik destek sağlıyoruz</li>
            </ul>
          </Paragraph>
        </div>

        {/* İletişim */}
        <div style={{ marginBottom: '32px' }}>
          <Title level={3} style={{ color: '#1890ff', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <MailOutlined /> İletişim
          </Title>
          <Card style={{ background: '#f0f9ff', borderLeft: '4px solid #1890ff' }}>
            <Paragraph>Sorularınız için:</Paragraph>
            <Space direction="vertical">
              <div>
                <MailOutlined /> <a href="mailto:iletisim@siparify.com">iletisim@siparify.com</a>
              </div>
              <div>
                <ClockCircleOutlined /> Pazartesi-Cuma 09:00-18:00
              </div>
            </Space>
          </Card>
        </div>

        {/* Yasal Bilgiler */}
        <div style={{ marginBottom: '32px' }}>
          <Title level={3} style={{ color: '#1890ff', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <FileTextOutlined /> Yasal Bilgiler
          </Title>
          <Paragraph>
            Bu şartlar Türk hukuku çerçevesinde geçerlidir. Uyuşmazlıklar İstanbul mahkemelerinde çözülür.
          </Paragraph>
        </div>

        {/* Footer */}
        <Divider />
        <div style={{ textAlign: 'center' }}>
          <Paragraph>
            Bu şartları kabul ederek Siparify'ı kullanmayı kabul etmiş olursunuz.
          </Paragraph>
          <Text strong style={{ color: '#1890ff', fontSize: '16px' }}>
            Siparify © 2025 | Tüm Hakları Saklıdır
          </Text>
        </div>
      </Card>
    </div>
  );
};

export default TermsOfServicePage;